export default __webpack_public_path__ + "static/media/quiz.38a4d70d.svg";